const statusCode = {
    LOADING:'loading',
    IDLE:'idle',
    ERROR:'error'
}
export default statusCode